define([
	"jquery"
],function($) {
	/*Dynamically inject the src for where to get it iframe.
	 *This helps improve loading time on the parent page.*/
	var $w2gMapIframes = $('iframe.where2getit');
	$(window).on ({
		scroll: function (event){
			$w2gMapIframes.each (function (){
				var $this = $(this);
				var rect = this.getBoundingClientRect();
				// Check if iframe is onscreen and set source so it can load
				if ((rect.top <= $(window).height()) && ($this.attr ('src') === "" || $this.attr ('src') === undefined) && $this.data('src')){
					$this.attr ('src', $this.data('src'));
				}
			});
		}
	});
});